import { connect } from 'react-redux';
import DriftActivationView from './DriftActivationView.jsx';
import { activateAccount, updateConfiguration } from 'src/legacy/redux/actions/chatIntegration.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
  return {
    integrations: state.legacyRootReducer.settings.integrations.activated.items,
    activating: state.legacyRootReducer.settings.integrations.chat.activation.activating,
    updating: state.legacyRootReducer.settings.integrations.chat.changes.saving,
    error: state.legacyRootReducer.settings.integrations.chat.activation.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount : (configuration, integrationType) => {
      return dispatch(activateAccount(configuration, integrationType))
    },
    updateConfiguration : (configuration, integrationType) => {
      return dispatch(updateConfiguration(configuration, integrationType))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const DriftActivationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(DriftActivationView);

export default DriftActivationPage;
